import { TeamChat } from '../features/team-chat';

export default function TeamChatPage() {
  return (
    <div className="h-[calc(100vh-4rem)]">
      <TeamChat />
    </div>
  );
}
